<div class="container">
  <ds-privacy-content></ds-privacy-content>
</div>
